import { useAuthStore } from "@/stores/auth";
import AssessmentListView from "@/views/AssessmentList.vue";
import GradingView from "@/views/GradingView.vue";
import ProfileSelectionView from "@/views/ProfileSelectionView.vue";
import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
import LoginView from "../views/LoginView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  // DISABLED: Signup route - accounts created through database seeding only
  // {
  //   path: "/signup",
  //   name: "signup",
  //   component: SignupView,
  // },
  {
    path: "/profile-selection",
    name: "profile-selection",
    component: ProfileSelectionView,
    meta: { requiresAuth: true },
  },
  {
    path: "/assessments",
    name: "assessments",
    component: AssessmentListView,
    meta: { requiresAuth: true, requiresProfile: true },
  },
  {
    path: "/grading/:id",
    name: "grading",
    component: GradingView,
    meta: { requiresAuth: true, requiresProfile: true },
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard to protect authenticated routes
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(
    (record) => record.meta.requiresAuth as boolean,
  );
  const requiresProfile = to.matched.some(
    (record) => record.meta.requiresProfile as boolean,
  );

  // Get the auth store instance
  const authStore = useAuthStore();

  // If auth is required, ensure auth is initialized first
  if (requiresAuth || requiresProfile) {
    // Only initialize if we have stored user data but no current user in store
    const storedUser = localStorage.getItem("user");

    if (storedUser && !authStore.isAuthenticated) {
      // Wait for auth initialization to complete
      await authStore.initializeAuth();
    }
  }

  if (requiresAuth && !authStore.isAuthenticated) {
    // Clear any stale data and redirect to login
    await authStore.logout();
    next({ name: "login" });
  } else if (requiresProfile && !authStore.isProfileSelected) {
    // User is authenticated but no profile selected, show profile selector
    if (to.name !== "profile-selection") {
      next({ name: "profile-selection" });
    } else {
      next(); // Allow access to the profile selection page
    }
  } else if (
    !requiresAuth &&
    authStore.isAuthenticated &&
    authStore.isProfileSelected &&
    (to.name === "login" || to.name === "signup")
  ) {
    // If user is authenticated with profile and tries to access login/signup, redirect to assessments
    next({ name: "assessments" });
  } else {
    next();
  }
});

export default router;
